import apiService from '@/modules/apis/apiService'
import { useMutation } from '@tanstack/react-query'
import { purchaseItemStore } from '@/store/purchase-item.store'
import { PurchaseItem } from '@/types/purchase.type'
import { getArtistLastPage } from '@/utils/artist-pathname'

type PurchaseItemListResponse = PurchaseItem[]

const getPurchaseItemList = async () => {
  const response = (await apiService.get('/api/v1/products/digital-packs', {
    params: {
      eventKey: getArtistLastPage(),
    },
  })) as any

  return response.data.result as PurchaseItemListResponse
}

export const usePurchaseItemListMutation = () => {
  return useMutation({
    mutationFn: getPurchaseItemList,
    onSuccess: (data) => {
      purchaseItemStore.getState().setPurchaseItemList(data)
    },
  })
}
